"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _getImportantRespondentFields = _interopRequireDefault(require("../../../helpers/getImportantRespondentFields.js"));
var _languageColumn = _interopRequireDefault(require("../../../helpers/languageColumn.js"));
var _admin = require("../../../selectors/admin.js");
var _respondentsByDeployment_identifiable = _interopRequireDefault(require("./respondentsByDeployment_identifiable.graphql"));
var _respondentsByDeployment_noIdentifiable = _interopRequireDefault(require("./respondentsByDeployment_noIdentifiable.graphql"));
var _respondentsByGroup_identifiable = _interopRequireDefault(require("./respondentsByGroup_identifiable.graphql"));
var _respondentsByGroup_noIdentifiable = _interopRequireDefault(require("./respondentsByGroup_noIdentifiable.graphql"));
var _respondentsFromResponses_identifiable = _interopRequireDefault(require("./respondentsFromResponses_identifiable.graphql"));
var _respondentsFromResponses_noIdentifiable = _interopRequireDefault(require("./respondentsFromResponses_noIdentifiable.graphql"));
var _flagRespondentsByDeployment_identifiable = _interopRequireDefault(require("./flagRespondentsByDeployment_identifiable.graphql"));
var _flagRespondentsByDeployment_noIdentifiable = _interopRequireDefault(require("./flagRespondentsByDeployment_noIdentifiable.graphql"));
var _flagRespondentsByGroup_identifiable = _interopRequireDefault(require("./flagRespondentsByGroup_identifiable.graphql"));
var _flagRespondentsByGroup_noIdentifiable = _interopRequireDefault(require("./flagRespondentsByGroup_noIdentifiable.graphql"));
var _flagRespondentsFromResponses_identifiable = _interopRequireDefault(require("./flagRespondentsFromResponses_identifiable.graphql"));
var _flagRespondentsFromResponses_noIdentifiable = _interopRequireDefault(require("./flagRespondentsFromResponses_noIdentifiable.graphql"));
var _index = _interopRequireDefault(require("../CertificateRender/index.js"));
var _flag = _interopRequireDefault(require("cccisd-icons/flag7"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _ToggleFlagForm = _interopRequireDefault(require("./ToggleFlagForm.js"));
var _FlagHistory = _interopRequireDefault(require("./FlagHistory.js"));
var _fileText = _interopRequireDefault(require("cccisd-icons/file-text"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;
var STATUS_MAP = ['Not Started', 'In Progress', 'Completed'];
var AssignmentStatusTable = /*#__PURE__*/function (_React$Component) {
  _inherits(AssignmentStatusTable, _React$Component);
  var _super = _createSuper(AssignmentStatusTable);
  function AssignmentStatusTable() {
    var _this;
    _classCallCheck(this, AssignmentStatusTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoading: true,
      assignmentProgressPath: '',
      pawnIdPath: '',
      userPath: '',
      query: '',
      variables: {},
      columns: [],
      deploymentType: null,
      closedRoster: null,
      roleHandles: []
    });
    _defineProperty(_assertThisInitialized(_this), "canSeeIdentifiable", function () {
      var assignment = _this.props.assignment;
      return Fortress.hasAccess('quest.view_identifiable_data', assignment.groupId);
    });
    _defineProperty(_assertThisInitialized(_this), "setDeploymentParams", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, projectDeployments, currentDeploymentIds, selectedDeployment;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                isLoading: true
              });
            case 2:
              _this$props = _this.props, projectDeployments = _this$props.projectDeployments, currentDeploymentIds = _this$props.currentDeploymentIds;
              if (currentDeploymentIds.length) {
                _context.next = 6;
                break;
              }
              _this.setState({
                isLoading: false
              });
              return _context.abrupt("return");
            case 6:
              selectedDeployment = projectDeployments.find(function (item) {
                return !item.archived && currentDeploymentIds[0] === item.deploymentId;
              });
              if (selectedDeployment) {
                _context.next = 10;
                break;
              }
              _this.setState({
                isLoading: false
              });
              return _context.abrupt("return");
            case 10:
              _context.next = 12;
              return _this.setState({
                deploymentType: selectedDeployment.type,
                closedRoster: selectedDeployment.settings.closedRoster,
                parentDeploymentId: selectedDeployment.parentDeploymentId,
                roleHandles: [selectedDeployment.roleHandle]
              });
            case 12:
              _context.next = 14;
              return _this.setGraphQLParams();
            case 14:
              _context.next = 16;
              return _this.setGraphQLColumns();
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "setGraphQLParams", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props2, assignment, currentDeploymentIds, pawnIdWhitelist, flagId, _this$state, deploymentType, closedRoster, roleHandles, parentDeploymentId, canSeeIdentifiable, assignmentProgressPath, pawnIdPath, userPath, query, deploymentId, variables;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, assignment = _this$props2.assignment, currentDeploymentIds = _this$props2.currentDeploymentIds, pawnIdWhitelist = _this$props2.pawnIdWhitelist, flagId = _this$props2.flagId;
              _this$state = _this.state, deploymentType = _this$state.deploymentType, closedRoster = _this$state.closedRoster, roleHandles = _this$state.roleHandles, parentDeploymentId = _this$state.parentDeploymentId;
              canSeeIdentifiable = _this.canSeeIdentifiable();
              assignmentProgressPath = 'assignmentProgress.';
              pawnIdPath = 'pawn.';
              userPath = '';
              query = canSeeIdentifiable ? _respondentsByGroup_identifiable["default"] : _respondentsByGroup_noIdentifiable["default"];
              if (flagId) {
                query = canSeeIdentifiable ? _flagRespondentsByGroup_identifiable["default"] : _flagRespondentsByGroup_noIdentifiable["default"];
              }
              deploymentId = currentDeploymentIds.length ? currentDeploymentIds[0] : 0;
              variables = _objectSpread({
                deploymentId: deploymentId,
                roleHandle: roleHandles
              }, flagId ? {
                flagId: flagId
              } : {});
              _context2.t0 = deploymentType;
              _context2.next = _context2.t0 === 'anon' ? 13 : _context2.t0 === 'known' ? 20 : _context2.t0 === 'group' ? 27 : 29;
              break;
            case 13:
              assignmentProgressPath = '';
              pawnIdPath = '';
              userPath = 'pawn.';
              query = canSeeIdentifiable ? _respondentsFromResponses_identifiable["default"] : _respondentsFromResponses_noIdentifiable["default"];
              if (flagId) {
                query = canSeeIdentifiable ? _flagRespondentsFromResponses_identifiable["default"] : _flagRespondentsFromResponses_noIdentifiable["default"];
              }
              variables = _objectSpread({
                deploymentId: deploymentId
              }, flagId ? {
                flagId: flagId
              } : {});
              return _context2.abrupt("break", 30);
            case 20:
              pawnIdPath = 'pawn.pawn.';
              userPath = 'pawn.';
              assignmentProgressPath = 'pawn.assignmentProgress.';
              query = canSeeIdentifiable ? _respondentsByDeployment_identifiable["default"] : _respondentsByDeployment_noIdentifiable["default"];
              if (flagId) {
                query = canSeeIdentifiable ? _flagRespondentsByDeployment_identifiable["default"] : _flagRespondentsByDeployment_noIdentifiable["default"];
              }
              variables = _objectSpread({
                // Get respondents list from Parent, but get Progress from Child.
                // If not repeatable, get both respondents and progress from same deployment.
                childDeploymentId: deploymentId,
                parentDeploymentId: parentDeploymentId || deploymentId
              }, flagId ? {
                flagId: flagId
              } : {});
              return _context2.abrupt("break", 30);
            case 27:
              if (closedRoster) {
                pawnIdPath = 'pawn.pawn.';
                userPath = 'pawn.';
                assignmentProgressPath = 'pawn.assignmentProgress.';
                query = canSeeIdentifiable ? _respondentsByDeployment_identifiable["default"] : _respondentsByDeployment_noIdentifiable["default"];
                if (flagId) {
                  query = canSeeIdentifiable ? _flagRespondentsByDeployment_identifiable["default"] : _flagRespondentsByDeployment_noIdentifiable["default"];
                }
                variables = _objectSpread({
                  // Get respondents list from Parent, but get Progress from Child.
                  // If not repeatable, get both respondents and progress from same deployment.
                  childDeploymentId: deploymentId,
                  parentDeploymentId: parentDeploymentId || deploymentId
                }, flagId ? {
                  flagId: flagId
                } : {});
              }
              return _context2.abrupt("break", 30);
            case 29:
              return _context2.abrupt("break", 30);
            case 30:
              variables.projectId = assignment.groupId;
              variables.pawnIds = pawnIdWhitelist;
              _context2.next = 34;
              return _this.setState({
                assignmentProgressPath: assignmentProgressPath,
                pawnIdPath: pawnIdPath,
                userPath: userPath,
                query: query,
                variables: variables
              });
            case 34:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "setGraphQLColumns", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props3, assignment, project, showBy, hideSystemId, setColumnDefinitions, flagId, _this$state2, assignmentProgressPath, deploymentType, pawnIdPath, userPath, roleHandles, canSeeIdentifiable, appdefRoles, columns, roleDefs, _iterator, _step, roleDef, importantFields, _iterator2, _step2, f, roleFilterOptions, hasFinalTest, isCourseWrapper, certificateToggle, finalColumns;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = _this.props, assignment = _this$props3.assignment, project = _this$props3.project, showBy = _this$props3.showBy, hideSystemId = _this$props3.hideSystemId, setColumnDefinitions = _this$props3.setColumnDefinitions, flagId = _this$props3.flagId;
              _this$state2 = _this.state, assignmentProgressPath = _this$state2.assignmentProgressPath, deploymentType = _this$state2.deploymentType, pawnIdPath = _this$state2.pawnIdPath, userPath = _this$state2.userPath, roleHandles = _this$state2.roleHandles;
              canSeeIdentifiable = _this.canSeeIdentifiable();
              appdefRoles = AppDefs.pawn.roles || [];
              columns = [];
              if (flagId) {
                columns.push({
                  name: 'flagHistory',
                  label: 'Flag History',
                  className: 'text-center',
                  render: function render(_ref4) {
                    var value = _ref4.value,
                      row = _ref4.row;
                    var haveHistory = row['flagProgress.log'] && row['flagProgress.log'].length > 0;
                    if (!haveHistory) {
                      return '-';
                    }
                    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                      title: "Flag history",
                      trigger: /*#__PURE__*/_react["default"].createElement("button", {
                        type: "button",
                        className: "btn btn-primary btn-xs"
                      }, /*#__PURE__*/_react["default"].createElement(_fileText["default"], null)),
                      size: "large"
                    }, /*#__PURE__*/_react["default"].createElement(_FlagHistory["default"], {
                      history: row['flagProgress.log']
                    }));
                  }
                });
                columns.push({
                  name: 'flag',
                  label: 'Flag Status',
                  className: 'text-center',
                  render: function render(_ref5) {
                    var value = _ref5.value,
                      row = _ref5.row,
                      loadData = _ref5.loadData;
                    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                      title: "".concat(row['flagProgress.status'] === 'flagged' ? 'Remove' : 'Add', " flag"),
                      trigger: /*#__PURE__*/_react["default"].createElement("button", {
                        type: "button",
                        className: (0, _classnames["default"])('btn btn-xs', row['flagProgress.status'] === 'flagged' ? 'btn-warning' : 'btn-default')
                      }, /*#__PURE__*/_react["default"].createElement(_flag["default"], null))
                    }, /*#__PURE__*/_react["default"].createElement(_ToggleFlagForm["default"], {
                      flagProgressId: row['flagProgress.flagProgressId'],
                      flagStatus: row['flagProgress.status'],
                      onSubmit: loadData
                    }));
                  }
                });
              }

              // System ID Column
              if (!hideSystemId) {
                columns.push({
                  name: "".concat(pawnIdPath, "pawnId"),
                  label: 'System ID',
                  sort: true,
                  filter: true
                });
              }
              roleDefs = appdefRoles.filter(function (item) {
                return roleHandles.includes(item.handle);
              }); // Important Fields columns (roles.json)
              _iterator = _createForOfIteratorHelper(roleDefs);
              _context3.prev = 9;
              _iterator.s();
            case 11:
              if ((_step = _iterator.n()).done) {
                _context3.next = 35;
                break;
              }
              roleDef = _step.value;
              importantFields = roleDef.importantFields || [];
              if (roleDef.handle === 'respondent') {
                importantFields = (0, _getImportantRespondentFields["default"])({
                  importantFields: importantFields,
                  project: project
                });
              }
              _iterator2 = _createForOfIteratorHelper(importantFields);
              _context3.prev = 16;
              _iterator2.s();
            case 18:
              if ((_step2 = _iterator2.n()).done) {
                _context3.next = 25;
                break;
              }
              f = _step2.value;
              if (!(!canSeeIdentifiable && f.identifiable)) {
                _context3.next = 22;
                break;
              }
              return _context3.abrupt("continue", 23);
            case 22:
              columns.push({
                name: "".concat(userPath, "important.").concat(f.path),
                label: f.label,
                sort: true,
                filter: true
              });
            case 23:
              _context3.next = 18;
              break;
            case 25:
              _context3.next = 30;
              break;
            case 27:
              _context3.prev = 27;
              _context3.t0 = _context3["catch"](16);
              _iterator2.e(_context3.t0);
            case 30:
              _context3.prev = 30;
              _iterator2.f();
              return _context3.finish(30);
            case 33:
              _context3.next = 11;
              break;
            case 35:
              _context3.next = 40;
              break;
            case 37:
              _context3.prev = 37;
              _context3.t1 = _context3["catch"](9);
              _iterator.e(_context3.t1);
            case 40:
              _context3.prev = 40;
              _iterator.f();
              return _context3.finish(40);
            case 43:
              // ----------------------------------------------

              // Anon deployment role column
              if (deploymentType === 'anon') {
                roleFilterOptions = appdefRoles.map(function (p) {
                  return {
                    label: p.label,
                    value: p.handle
                  };
                });
                columns.push({
                  name: 'pawn.pawn.role',
                  label: 'Role',
                  sort: true,
                  filter: true,
                  filterSettings: {
                    type: 'selectbox',
                    options: roleFilterOptions
                  },
                  render: function render(_ref6) {
                    var value = _ref6.value;
                    var roleDef = appdefRoles.find(function (r) {
                      return r.handle === value;
                    });
                    return roleDef ? roleDef.label : value;
                  }
                });
              }
              // ---------------------------------------------------

              columns = (0, _uniqBy2["default"])(columns, 'name');

              // Languages column
              if (assignment.settings.languages.length > 1) {
                columns.push((0, _languageColumn["default"])({
                  name: "".concat(assignmentProgressPath, "language")
                }));
              }

              // Survey List
              if (assignment.surveylistList.length > 1) {
                columns.push({
                  name: "".concat(assignmentProgressPath, "flowList"),
                  label: 'Surveylist',
                  sort: true,
                  filter: true
                });
              }
              hasFinalTest = assignment.settings.navigationSettings.finalTest && assignment.settings.navigationSettings.finalTest.toggle;
              isCourseWrapper = assignment.settings.navigation.includes('courseWrapper');
              certificateToggle = assignment.settings.navigationSettings.certificate && assignment.settings.navigationSettings.certificate.toggle;
              _context3.t2 = showBy;
              _context3.next = _context3.t2 === 'assignment' ? 53 : _context3.t2 === 'module' ? 57 : _context3.t2 === 'survey' ? 59 : 61;
              break;
            case 53:
              // Status / Certificate Columns
              _this.addAssignmentStatusColumns(columns);
              if (isCourseWrapper && certificateToggle) {
                _this.addCertificateColumn(columns);
              }
              if (hasFinalTest) {
                _this.addScoreDuration(columns);
              }
              return _context3.abrupt("break", 62);
            case 57:
              _this.addModuleStatusColumns(columns);
              return _context3.abrupt("break", 62);
            case 59:
              _this.addSurveyStatusColumns(columns);
              return _context3.abrupt("break", 62);
            case 61:
              return _context3.abrupt("break", 62);
            case 62:
              finalColumns = setColumnDefinitions ? setColumnDefinitions(columns) : columns;
              _context3.next = 65;
              return _this.setState({
                columns: finalColumns,
                isLoading: false
              });
            case 65:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 37, 40, 43], [16, 27, 30, 33]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "addScoreDuration", function (columns) {
      var assignmentProgressPath = _this.state.assignmentProgressPath;
      columns.push({
        name: "".concat(assignmentProgressPath, "variables"),
        label: 'Score',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref7) {
          var value = _ref7.value,
            row = _ref7.row;
          var assignmentHandle = row['assignmentProgress.assignmentHandle'];
          var testScore = row["assignmentProgress.variables.".concat(assignmentHandle, "_test_score")];
          if (!testScore) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement("div", null, testScore);
        }
      });
      columns.push({
        name: "".concat(assignmentProgressPath, "assignmentHandle"),
        label: 'Duration',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref8) {
          var value = _ref8.value,
            row = _ref8.row;
          var assignmentHandle = row['assignmentProgress.assignmentHandle'];
          var duration = row["assignmentProgress.variables.".concat(assignmentHandle, "_duration")];
          if (!duration) {
            return null;
          }
          var hours = Math.floor(duration / 3600);
          var minusHours = duration - hours * 3600;
          var minutes = Math.floor(minusHours / 60);
          var seconds = minusHours - minutes * 60;
          var strPadLeft = function strPadLeft(string, pad, length) {
            return (new Array(length + 1).join(pad) + string).slice(-length);
          };
          var finalTime = strPadLeft(hours, '0', 2) + ':' + strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2);
          return /*#__PURE__*/_react["default"].createElement("div", null, finalTime);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addAssignmentStatusColumns", function (columns) {
      var assignment = _this.props.assignment;
      var _this$state3 = _this.state,
        userPath = _this$state3.userPath,
        assignmentProgressPath = _this$state3.assignmentProgressPath;
      columns.push({
        name: "".concat(assignmentProgressPath, "lastVisitedAt"),
        label: 'Last Visited',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'date'
        }
      });
      columns.push({
        name: "".concat(userPath, "assignmentProgressStatus.assignment").concat(assignment.assignmentId),
        label: 'Status',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'selectbox',
          placeholder: '-- Choose one --',
          options: [{
            label: STATUS_MAP[0],
            value: 0
          }, {
            label: STATUS_MAP[1],
            value: 1
          }, {
            label: STATUS_MAP[2],
            value: 2
          }]
        },
        render: function render(_ref9) {
          var value = _ref9.value,
            row = _ref9.row;
          if (value > 0) {
            // let key = `assignmentProgressStatus.assignment${assignment.assignmentId}_lastVisit`;
            return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)]);
          }
          return STATUS_MAP[0];
        }
      });
      columns.push({
        name: "".concat(assignmentProgressPath, "completedAt"),
        label: 'Completed At',
        sort: true,
        filter: true,
        filterSettings: {
          type: 'date'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addCertificateColumn", function (columns) {
      var userPath = _this.state.userPath;
      var deploymentId = _this.state.variables.deploymentId;
      var deployment = _this.props.currentDeployments.find(function (item) {
        return item.deploymentId === deploymentId;
      });
      columns.push({
        name: "".concat(userPath, "pawn.pawnHash"),
        label: 'Certificate',
        className: 'text-center',
        hideInCsv: true,
        render: function render(_ref10) {
          var value = _ref10.value,
            row = _ref10.row;
          var certificateProps = {
            actingPawnId: row['pawn.pawnId'] ? row['pawn.pawnId'] : row['pawn.pawn.pawnId'],
            actingPawnHash: row['pawn.pawnHash'] ? row['pawn.pawnHash'] : row['pawn.pawn.pawnHash'],
            deploymentId: _this.state.variables.deploymentId,
            deploymentSettings: deployment.settings,
            language: row['assignmentProgress.language'] || row.language
          };
          return /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, certificateProps, {
            row: row,
            renderCertificate: _this.props.renderCertificate
          }));
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "addModuleStatusColumns", function (columns) {
      var _this$props4 = _this.props,
        assignment = _this$props4.assignment,
        modules = _this$props4.modules;
      var userPath = _this.state.userPath;
      var _iterator3 = _createForOfIteratorHelper(modules),
        _step3;
      try {
        var _loop = function _loop() {
          var m = _step3.value;
          columns.push({
            name: "".concat(userPath, "moduleProgressStatus.assignment").concat(assignment.assignmentId, "_module").concat(m.id),
            label: m.title,
            sort: true,
            filter: true,
            filterSettings: {
              type: 'selectbox',
              placeholder: '-- Choose one --',
              options: [{
                label: STATUS_MAP[0],
                value: 0
              }, {
                label: STATUS_MAP[1],
                value: 1
              }, {
                label: STATUS_MAP[2],
                value: 2
              }]
            },
            render: function render(_ref11) {
              var value = _ref11.value,
                row = _ref11.row;
              if (value > 0) {
                var key = "moduleProgressStatus.assignment".concat(assignment.assignmentId, "_module").concat(m.id, "_lastVisit");
                return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)], /*#__PURE__*/_react["default"].createElement("br", null), row[key]);
              }
              return STATUS_MAP[0];
            }
          });
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "addSurveyStatusColumns", function (columns) {
      var surveys = _this.props.surveys;
      var userPath = _this.state.userPath;
      var uniqueHandles = (0, _sortBy2["default"])((0, _uniqBy2["default"])(surveys.filter(function (s) {
        return !s.archived;
      }), 'surveyHandle'), 'position');
      var _iterator4 = _createForOfIteratorHelper(uniqueHandles),
        _step4;
      try {
        var _loop2 = function _loop2() {
          var s = _step4.value;
          columns.push({
            name: "".concat(userPath, "surveyProgressStatus.").concat(s.surveyHandle),
            label: s.label,
            sort: true,
            filter: true,
            filterSettings: {
              type: 'selectbox',
              placeholder: '-- Choose one --',
              options: [{
                label: STATUS_MAP[0],
                value: 0
              }, {
                label: STATUS_MAP[1],
                value: 1
              }, {
                label: STATUS_MAP[2],
                value: 2
              }]
            },
            render: function render(_ref12) {
              var value = _ref12.value,
                row = _ref12.row;
              if (value > 0) {
                var key = "surveyProgressStatus.".concat(s.surveyHandle, "_lastVisit");
                return /*#__PURE__*/_react["default"].createElement("div", null, STATUS_MAP[Number.parseInt(value, 10)], /*#__PURE__*/_react["default"].createElement("br", null), row[key]);
              }
              return STATUS_MAP[0];
            }
          });
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
    return _this;
  }
  _createClass(AssignmentStatusTable, [{
    key: "componentDidMount",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // LIFECYCLE METHODS //////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function componentDidMount() {
      this.setDeploymentParams();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // if the list of deployment IDs, surveysWhiteList, or pawnIdWhitelist changed...
      if (!(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.currentDeploymentIds, this.props.currentDeploymentIds)) || !(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.surveys, this.props.surveys)) || !(0, _isEmpty2["default"])((0, _xor2["default"])(prevProps.pawnIdWhitelist, this.props.pawnIdWhitelist))) {
        this.setDeploymentParams();
      } else if (prevProps.showBy !== this.props.showBy) {
        this.setGraphQLColumns();
      }
    }

    /* /////////////////////////////////////////////////////////////////////////
    // GENERAL METHODS ////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this$state4 = this.state,
        columns = _this$state4.columns,
        isLoading = _this$state4.isLoading,
        pawnIdPath = _this$state4.pawnIdPath,
        query = _this$state4.query,
        variables = _this$state4.variables;
      if (isLoading || !query) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
        columns: columns,
        query: query,
        rowKey: "".concat(pawnIdPath, "pawnId"),
        graphqlVariables: variables
      });
    }
  }]);
  return AssignmentStatusTable;
}(_react["default"].Component);
_defineProperty(AssignmentStatusTable, "propTypes", {
  // from redux state
  assignment: _propTypes["default"].object,
  currentDeploymentIds: _propTypes["default"].array,
  currentDeployments: _propTypes["default"].array,
  pawnIdWhitelist: _propTypes["default"].arrayOf(_propTypes["default"].number),
  project: _propTypes["default"].object,
  projectDeployments: _propTypes["default"].array,
  surveys: _propTypes["default"].array,
  modules: _propTypes["default"].array,
  showBy: _propTypes["default"].string.isRequired,
  hideSystemId: _propTypes["default"].bool,
  // From ExportStatus
  renderCertificate: _propTypes["default"].func,
  setColumnDefinitions: _propTypes["default"].func,
  flagId: _propTypes["default"].number
});
_defineProperty(AssignmentStatusTable, "defaultProps", {
  // from redux state
  assignment: {},
  projectDeployments: [],
  currentDeploymentIds: [],
  hideSystemId: false,
  renderCertificate: null,
  setColumnDefinitions: null
});
var mapStateToProps = function mapStateToProps(state, props) {
  var surveyHandleWhitelist = props.surveyHandleWhitelist;
  var surveys = (0, _admin.getCurrentAssignmentSurveys)(state.assignment.admin);
  if (Array.isArray(surveyHandleWhitelist)) {
    surveys = surveys.filter(function (survey) {
      return surveyHandleWhitelist.includes(survey.surveyHandle);
    });
  }
  return {
    assignment: (0, _admin.getCurrentAssignment)(state.assignment.admin),
    currentDeploymentIds: state.assignment.admin.currentDeploymentIds,
    currentDeployments: (0, _admin.getCurrentDeployments)(state.assignment.admin),
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    projectDeployments: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin),
    surveys: surveys
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(AssignmentStatusTable);
exports["default"] = _default;